import React from "react";
import { useState } from 'react';
import './Perifericos.css';
import imgTecladoMouse from '../../assets/images/TECLADOS.png';
import imgMouse from '../../assets/images/mouses.png';
import imgMONITORES from '../../assets/images/MONITORES.png';
import imgImpresora from '../../assets/images/impresoraaaa.png';
import imgESCANERS from '../../assets/images/handhelp.png';
import imgCAMARASWEB from '../../assets/images/camrasegu.png';
import imgHUBUSB from '../../assets/images/HUBUSB.png';
import imgAuriculares from '../../assets/images/Audi.png';
import imgBases from '../../assets/images/soportescom.webp';
import imgCONECTORES from '../../assets/images/conectores.png';
import imgControladores from '../../assets/images/Controladores.webp';
import imgEntrada from '../../assets/images/Proyector.png';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Ubi from '../../assets/images/Ubi.png';
import Telefono from '../../assets/images/Telefono.png';
import Email34 from '../../assets/images/Correo.png';
import checkAnim from '../../assets/images/check.gif';
import RedesFondo from '../../assets/images/Red-Neuronal.png';

import { FaWhatsapp } from 'react-icons/fa';
{/* Bloque de menú catalogo Periféricos */}
const categoriasPerifericos = [
  {
    //Item 1 catalogo Periféricos 
    titulo: 'Teclados',
    img: imgTecladoMouse,
    marcas: ['Logitech', 'HP', 'Dell', 'Redragon', 'Microsoft'],
  },
  {
    //Item 2 catalogo Periféricos 
    titulo: 'Mouse',
    img: imgMouse,
    marcas: ['Logitech', 'HP', 'Razer', 'Dell', 'Genius'],
  },
  {
    //Item 3 catalogo Periféricos 
    titulo: 'Monitores',
    img: imgMONITORES,
    marcas: ['Samsung', 'Dell', 'BenQ', 'LG', 'ViewSonic'],
  },
  {
    //Item 4 catalogo Periféricos 
    titulo: 'Impresoras',
    img: imgImpresora,
    marcas: ['Canon', 'Xerox', 'Zebra', 'Brother', 'Epson', 'HP'],
  },
  {
    //Item 5 catalogo Periféricos 
    titulo: 'HandHeld',
    img: imgESCANERS,
    marcas: ['Zebra', 'HoneyWell', 'Datalogic', 'Point Mobile', 'NewLand'],
  },
  {
    //Item 6 catalogo Periféricos 
    titulo: 'Cámaras de Seguridad',
    img: imgCAMARASWEB,
    marcas: ['TP-Link', 'Logitech', 'Dahua', 'Hikvision'],
  },
  {
    //Item 7 catalogo Periféricos 
    titulo: 'Auriculares',
    img: imgAuriculares,
    marcas: ['Sony', 'Jabra', 'Logitech', 'HyperX', 'Razer'],
  },
  {
    //Item 8 catalogo Periféricos 
    titulo: 'Proyectores',
    img: imgEntrada,
    marcas: ['Epson', 'BenQ', 'ViewSonic', 'Optoma', 'Panasonic'],
  },
  {
    //Item 9 catalogo Periféricos 
    titulo: 'Hubs USB',
    img: imgHUBUSB,
    marcas: ['TP-Link', 'Ugreen', 'Anker', 'Satechi', 'Belkin'],
  },
  {
    //Item 10 catalogo Periféricos 
    titulo: 'Bases y Soportes',
    img: imgBases,
    marcas: ['Cooler Master', 'Kensington', 'Trust', 'Fellowes', 'AmazonBasics'],
  },
  {
    //Item 11 catalogo Periféricos 
    titulo: 'Conectores',
    img: imgCONECTORES,
    marcas: ['Belkin', 'Ugreen', 'Anker', 'Tripp Lite', 'StarTech'],
  },
  {
    //Item 12 catalogo Periféricos 
    titulo: 'Controladores',
    img: imgControladores,
    marcas: ['Xbox', 'PlayStation', 'Logitech', 'PowerA', '8BitDo'],
  },
];

function Perifericos() {
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
    }).then(() => {
      setEnviado(true);
      form.reset();
    });
  };

  return (
    <>
    {/*Bloque de inicio catalogo Periféricos */}
      <section className="perifericos-white-section">
        <div className="perifericos-header">
          {/*Titulo de catalogo Periféricos */}
          <h2 className="perifericos-titulo">Periféricos y Accesorios</h2>

          <div className="perifericos-texto-lateral">
            {/*Descripción catalogo Periféricos */}
            <p className="perifericos-contacto-descripcion">
              Productos funcionales, compatibles y con garantía de fábrica.
            </p>
          </div>
        </div>

        <div className="perifericos-grid">
          {categoriasPerifericos.map((cat, idx) => (
            <div className="perifericos-item" key={idx}>
              <div className="perifericos-img">
                <img src={cat.img} alt={cat.titulo} />
              </div>
              <div className="perifericos-texto">
                <h3>{cat.titulo}</h3>
                <p className="perifericos-marcas">
                  {cat.marcas.map((marca, i) => (
                    <span key={i} className="perifericos-marca-texto">
                      {marca}
                    </span>
                  ))}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="perifericos-contacto">
          {/*Sugerencia whatsapp catalogo Periféricos */}
          ¿Necesitas algún accesorio en particular? Podemos conseguirlo.<br />
          &nbsp;&nbsp;&nbsp;&nbsp;Ponte en contanto con{' '}
          <a
            href="https://wa.me/525567786252"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-link"
          >
            nosotros <FaWhatsapp className="whatsapp-icon-inline" />
          </a>
        </p>
      </section>

       {/* Contenedor principal del formulario de contacto */}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
    {/*Titulo cambiado formulario catalogo Perifericos */}
  {!enviado ? (
    'Elige tus Accesorios ideales. ¡Cotiza ahora!'
  ) : (
    <>
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo  Numero Telefonico*/}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario */}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      <img src={checkAnim} alt="Éxito" />
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>



{/* Contenedor principal  de pie de pagina con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Comercializacion">• Ver mas Infraestructura TI</a></li>
        <li><a href="/">• IAutomatizacion CFDI</a></li>
         
        <li><a href="/Facturacion">• Facturación Electrónica</a></li>
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Instagram Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
         {/*Sobre Nostros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
         {/*Facturacion Electronica Colum 3*/}
        {/*Servicios Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

{/* Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>
<a
  href="https://wa.me/525567786252"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-bubble"
>
  <FaWhatsapp size={35} color="#fff" />
</a>
    </>
  );
}


export default Perifericos;